<div class="container main-content">
  <div class="page-header">
    <h2>Renewals</h2>
    <span class="flex-fill"></span>
    <span class="space-fill"></span>
    <app-search-bar (search)="search($event)"></app-search-bar>
  </div>

  <app-renewals-grid></app-renewals-grid>
</div>
